export default __webpack_public_path__ + "static/media/IconDesc_ConversionCube.256.600e5ba1.png";